import React from 'react';
import { TDR } from 'tdr-common';
import { EventSelectionBanner } from '../events/EventSelectionBanner';

type EventBookingBannerProps = {
	matchingEvents: TDR.Event[];
};

export const EventBookingBanner = ({ matchingEvents }: EventBookingBannerProps) => (
	<EventSelectionBanner events={matchingEvents} />
);
